import * as Yup from 'yup'
import CustomFieldType from 'constants/CustomFieldTypes'

export const EMPTY_TRANSLATIONS = {
  de: '',
  en: '',
  pl: ''
}

export const DEFAULT_TEXT_MAX_CHAR_COUNT = 255

export const INITIAL_VALUES = {
  module: undefined,
  section: undefined,
  type: CustomFieldType.Text,
  translations: EMPTY_TRANSLATIONS,
  isEnabled: true,
  isRequired: false,
  isVisibleOnPrint: false,
  maxCharCount: DEFAULT_TEXT_MAX_CHAR_COUNT,
  defaultValue: {
    text: '',
  }
}

const defaultValueSchema = (type) => {
  switch (type) {
    case CustomFieldType.Text:
      return Yup.object().shape({
        text: Yup.string()
      })
    case CustomFieldType.Boolean:
      return Yup.object().shape({
        bool: Yup.bool().required()
      })
    case CustomFieldType.Date:
      return Yup.object().shape({
        date: Yup.date().nullable()
      })
    case CustomFieldType.DateTime:
      return Yup.object().shape({
        dateTime: Yup.date().nullable()
      })
    default:
      return Yup.object()
  }
}

const selectOptionSchema = Yup.object().shape({
  translations: Yup.object().shape({
    de: Yup.string().required(),
    en: Yup.string().required(),
    pl: Yup.string().required(),
  }),
  isDefault: Yup.bool().required()
}).required()

export const createValidationSchema = () =>
  Yup.object().shape({
    module: Yup.string().required(),
    section: Yup.string().required().nullable(),
    type: Yup.string().required(),
    translations: Yup.object().shape({
      de: Yup.string().required(),
      en: Yup.string().required(),
      pl: Yup.string().required()
    }).required(),
    isEnabled: Yup.bool().required(),
    isRequired: Yup.bool().required(),
    isVisibleOnPrint: Yup.bool().required(),
    defaultValue: Yup.object()
      .when('type', (type) => defaultValueSchema(type)),
    maxCharCount: Yup.number()
      .when('type', (type, schema) => {
        if (type === CustomFieldType.Text)
          return schema.min(1).required()
      }),
    selectOptions: Yup.array().of(selectOptionSchema)
      .when('type', (type, schema) => {
        if (type === CustomFieldType.Select)
          return schema.min(1).required()
      })
  })

export function toFormValues (customField) {
  const getDefaultValueByType = (defaultValue, type) => {
    switch (type) {
      case CustomFieldType.Boolean:
        return { bool: defaultValue }
      case CustomFieldType.Date:
        return { date: defaultValue }
      case CustomFieldType.DateTime:
        return { dateTime: defaultValue }
      case CustomFieldType.Text:
        return { text: defaultValue }
      default:
        return undefined
    }
  }
  const {
    module,
    section,
    type,
    translations,
    isEnabled,
    isRequired,
    isVisibleOnPrint,
    defaultValue,
    maxCharCount,
    selectOptions
  } = customField
  return ({
    module,
    section,
    type,
    translations,
    isEnabled,
    isRequired,
    isVisibleOnPrint,
    defaultValue: getDefaultValueByType(defaultValue, type),
    maxCharCount,
    selectOptions
  })
}
